var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelGoogleplus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.352 6a6.33 6.33 0 0 1 4.275 1.653c-1.33 1.256-1.286 1.33-1.809 1.853-.652-.54-1.364-.927-2.466-.927-2.084 0-3.71 1.69-3.71 3.773s1.626 3.774 3.71 3.774c2.06 0 2.896-.888 3.434-2.52-.914 0-3.053.004-3.389.004h-.045v-2.516h6.1c.426 3.044-.856 7.61-6.1 7.61A6.352 6.352 0 0 1 8.352 6m11.826 3.63v1.816H22v1.841h-1.822v1.787H18.39v-1.787h-1.845v-1.841h1.845V9.63z"
})));
export default SvgGemChannelGoogleplus;